import { IonContent } from '@ionic/react';
import React from 'react';

import {
  ChoicePanel,
  ChoicePanelProps,
} from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/components/ChoicePanel';

import { PageStyles } from './GenericScreenLayout.styles.ts';

type GenericSceneLayoutProps = {
  backgroundImage: string;
  title: ChoicePanelProps['title'];
  choices: ChoicePanelProps['options'];
};

export const GenericScreenLayout: React.FC<GenericSceneLayoutProps> = ({
  backgroundImage,
  title,
  choices,
}) => {
  return (
    <PageStyles backgroundImage={backgroundImage} background={'dark-forest'}>
      <IonContent>
        <div className="content-wrapper">
          <ChoicePanel title={title} options={choices} />
        </div>
      </IonContent>
    </PageStyles>
  );
};
